import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import InputField from "components/fields/InputField";
import { useFormik } from "formik";
import Select from "react-select";

import * as Yup from "yup";
import { useAuth } from "context/AuthProvider";
import authImg from "assets/img/auth/logo.svg";
// const countries = require("countries-list");
import { countries } from "countries-list";
import Request from "helpers/request";

function Register() {
  const { retrieveToken } = useAuth();
  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState({});
  const [successState, setSuccessState] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countryCode, setCountryCode] = useState("");

  const token = retrieveToken();

  const validationSchema = Yup.object().shape({
    fullname: Yup.string()
      .matches(/^[A-Za-z\s'-]{2,}$/, "Invalid name")
      .required("Name is required"),
    email: Yup.string()
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "Invalid email address"
      )
      .required("Email is required"),
    contact_no: Yup.string().required("Contact number is required"),
    organization_name: Yup.string()
      .matches(/^[A-Za-z\s'-]{3,}$/, "Invalid organization name")
      .required("Organization name is required"),
  });

  useEffect(() => {
    if (token) {
      navigate("/admin");
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      fullname: "",
      email: "",
      contact_no: "",
      organization_name: "",
    },
    validationSchema: validationSchema,

    onSubmit: (values) => {
      // Your login action here

      setValidationErrors({});
      setIsSubmitting(true);
      Request.postJson("user/", values)
        .then((r) => {
          setIsSubmitting(false);
          localStorage.setItem("token", r.data.data.access_token);
          navigate("/check-email");
          console.log(r);
        })
        .catch((e) => {
          setIsSubmitting(false);
          if (e.response.data.detail !== undefined) {
            setValidationErrors(e.response.data.detail);
          }
          if (e.response.data.error !== undefined) {
            setValidationErrors(e.response.data.error);
          }
          if (Object.keys(validationErrors).length !== 0) {
            setSuccessState("error");
          }
          console.log(e);
        });
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="mt-[170px] mb-16 flex w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        {/* Sign in section */}
        <div className="w-full max-w-full flex-col items-center rounded-xl p-6 shadow-[0_0px_6px_rgba(0,0,0,0.1)] xl:max-w-[420px]">
          <img
            className="mt-[-70px] mr-auto ml-auto rounded-[50px] bg-white"
            src={authImg}
            alt=""
          />
          <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
            Register
          </h4>
          <p className="mb-4 ml-1 text-base text-gray-600">
            Enter your details to register!
          </p>
          {Object.keys(validationErrors).length !== 0 && (
            <small className="mb-3 ml-1 text-center text-red-600">
              {validationErrors.message}
            </small>
          )}
          {/* Name */}
          <div className="mb-3">
            <InputField
              required="*"
              variant="auth"
              extra=""
              label="Name"
              placeholder="John Doe"
              id="fullname"
              type="text"
              name="fullname"
              value={formik.values.fullname}
              onchange={formik.handleChange}
              state={
                formik.touched.fullname && formik.errors.fullname ? "error" : ""
              }
            />
            {formik.touched.fullname && formik.errors.fullname && (
              <small className="ml-1.5 text-[12px] text-red-600">
                {formik.errors.fullname}
              </small>
            )}
          </div>
          {/* Email */}
          <div className="mb-3">
            <InputField
              required="*"
              variant="auth"
              extra=""
              label="Email"
              placeholder="mail@johndoe.com"
              id="email"
              type="text"
              name="email"
              value={formik.values.email}
              onchange={formik.handleChange}
              state={formik.touched.email && formik.errors.email ? "error" : ""}
            />
            {formik.touched.email && formik.errors.email && (
              <small className="ml-1.5 text-[12px] text-red-600">
                {formik.errors.email}
              </small>
            )}
          </div>
          {/* Contact No. */}
          <div className="mb-3">
            <InputField
              required="*"
              variant="auth"
              extra=""
              label="Contact No."
              placeholder="eg. 0987654321"
              id="contact_no"
              type="tel"
              name="contact_no"
              value={countryCode}
              onchange={formik.handleChange}
              state={
                formik.touched.contact_no && formik.errors.contact_no
                  ? "error"
                  : ""
              }
              countryCode={countryCode} // Pass the countryCode state
              onCountryCodeChange={(selectedCountryCode) => {
                // Update formik.values.contact_no with the selectedCountryCode
                formik.setFieldValue("contact_no", "+" + selectedCountryCode);
                // Update the countryCode state
                setCountryCode(selectedCountryCode);
              }} // Pass the function to update countryCode
            />
            {formik.touched.contact_no && formik.errors.contact_no && (
              <small className="ml-1.5 text-[12px] text-red-600">
                {formik.errors.contact_no}
              </small>
            )}
          </div>
          {/* Organization Name */}
          <div className="mb-3">
            <InputField
              required="*"
              variant="auth"
              extra=""
              label="Organization Name"
              placeholder="eg. ABC Pvt Ltd."
              id="organization_name"
              type="text"
              name="organization_name"
              value={formik.values.organization_name}
              onchange={formik.handleChange}
              state={
                formik.touched.organization_name &&
                formik.errors.organization_name
                  ? "error"
                  : ""
              }
            />
            {formik.touched.organization_name &&
              formik.errors.organization_name && (
                <small className="ml-1.5 text-[12px] text-red-600">
                  {formik.errors.organization_name}
                </small>
              )}
          </div>
          {/* Checkbox */}
          <button
            disabled={isSubmitting}
            type="submit"
            className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            {isSubmitting ? "Please wait..." : "Create Account"}
          </button>
          <div className="mt-4">
            <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
              Have an Account ?
            </span>
            {
              <Link
                to="/sign-in"
                className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
              >
                Sign In
              </Link>
            }
          </div>
        </div>
      </div>
    </form>
  );
}
export default Register;
